<ng-content />

@if (isMobile() && single(); as action) {
  <button type="button" mat-icon-button class="noRipple uvIconAction" [disableRipple]="true"
    [class.iconInfoButton]="!action.warn" [class.iconDeleteButton]="action.warn" [disabled]="action.disabled"
    [attr.aria-label]="action.label" (click)="action.trigger()">
    <div [innerHTML]="icons()[action.icon()]" class="svg"></div>
  </button>
} @else if (isMobile() && actions().length) {
  <button type="button" mat-icon-button class="menuButton noRipple uvMenuToggle" [disableRipple]="true"
    [matMenuTriggerFor]="menu" [attr.aria-label]="'GENERAL.MORE_ACTIONS' | translate">
    <div [innerHTML]="icons()['menu']" class="svg"></div>
  </button>

  <mat-menu #menu="matMenu" xPosition="before">
    <ng-template matMenuContent>
      @for (action of actions(); track action) {
        <button type="button" mat-menu-item [disabled]="action.disabled" (click)="action.trigger()">
          <span class="linkText" [class.warnColorText]="action.warn">{{ action.label }}</span>
        </button>
      }
    </ng-template>
  </mat-menu>
}
